// Fixed, non-sensitive language. Never render response bodies or credentials.
export function provenanceFailure(status) {
  if (status === 401) return 'Provenance session was not accepted (401). Sign in again to check provenance.'
  if (status === 403) return 'Provenance access was refused (403). This session is not permitted to read it.'
  if (status === 503) return 'Provenance service is temporarily unavailable (503). This is not an authorization refusal.'
  if (Number.isInteger(status) && status >= 400) return `Provenance service request failed (HTTP ${status}).`
  return 'Provenance could not be read. The service or connection may be unavailable.'
}
export function provenanceHttpError(status) {
  const error = new Error(provenanceFailure(status))
  error.status = status
  return error
}
